/**
 * Mobile device detection and overlay management
 */

export const initializeMobileDetection = () => {
  // Check if device is mobile and show overlay if needed
  function isMobileDevice() {
    return (
      window.innerWidth <= 1023 ||
      (navigator.maxTouchPoints > 0 && /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    );
  }

  function checkMobileDevice() {
    const mobileOverlay = document.getElementById('mobileOverlay');
    if (!mobileOverlay) return;
    if (isMobileDevice()) {
      mobileOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling behind overlay
    } else {
      mobileOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    }
  }

  // Run mobile check on page load
  checkMobileDevice();

  // Run mobile check on window resize
  window.addEventListener('resize', checkMobileDevice);
};
